export default __webpack_public_path__ + "static/media/metronome_click.8720e669.mp3";